// extracted by mini-css-extract-plugin
module.exports = {"container":"SwitchButton_container__1sy7d","button":"SwitchButton_button__2k_nz","text":"SwitchButton_text__2gVIP","selected":"SwitchButton_selected__3aZrP"};